import React, { useState, useEffect } from 'react';
import { Card, CardBody, Typography, Input, Button } from "@material-tailwind/react";
import axios from 'axios';
import { FaTrash, FaPlus, FaCheck, FaTimes, FaPenAlt } from 'react-icons/fa';
import { useAuth } from '../AuthContext';
import Alerty from '../../common/Alerty';
const { rootUrl } = require('../../../config/config');

const OwnersStatus = () => {
    const [statuses, setStatuses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [, setNewCode] = useState('');
    const [editName, setEditName] = useState('');
    const [editCode, setEditCode] = useState('');
    const [newName, setNewName] = useState('');
    const { user } = useAuth();

    const [editActive, setEditActive] = useState(false);
    const [newActive, setNewActive] = useState(false);

    const createStatus = async (e) => {

        e.preventDefault();
        if ( !newName.trim()) {
            setError('name are required.');
            return;
        }
        try {
            await axios.post(`${rootUrl}/owner-status`, {
                
                name: newName.toUpperCase(),
                active: true,
                input_by: user.username
            });
            // clear inputs
            setNewCode('');
            setNewName('');
            setNewActive(false);
            setError('');
            fetchStatuses();
        } catch (err) {
            const errorMessage = err.response?.data?.message || 'Failed to create new owner status.';
            setError(errorMessage);
        }
    };

    const fetchStatuses = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${rootUrl}/owner-status`);
            setStatuses(response.data.data);
            setError('');
        } catch (err) {
            const errorMessage = err.response?.data?.message || 'Failed to fetch owner statuses.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStatuses();
    }, []);

    const startEdit = (status) => {
        setEditingId(status.id);
        setEditCode(status.code);
        setEditName(status.name);
        setEditActive(status.active)
    };

    const cancelEdit = () => {
        setEditingId(null);
        setEditCode('');
        setEditName('');
        setEditActive(false)
    };

    const saveEdit = async (id) => {
        try {
            await axios.put(`${rootUrl}/owner-status/${id}`, { code: editCode, name: editName.toUpperCase(), active: editActive, edit_by: user.username });
            cancelEdit();
            fetchStatuses();
        } catch (err) {
            const errorMessage = err.response?.data?.message || 'Failed to update owner status.';
            setError(errorMessage);
        }
    };

    const deleteStatus = async (id) => {
        if (!window.confirm('Are you sure you want to delete this owner status?')) return;
        try {
            await axios.delete(`${rootUrl}/owner-status/${id}`);
            fetchStatuses();
        } catch (err) {
            const errorMessage = err.response?.data?.message || 'Failed to delete owner status.';
            setError(errorMessage);
        }
    };



    return (
        <>
            <Card className="w-full md:max-w-4xl mt-6 border-t">
                <CardBody>
                    <h2 className="text-2xl font-semibold text-gray-800 mb-6">Owners Statuses</h2>
                    {error && (
                        <div className='mb-3'>
                            <Alerty color='orange' message={error} setOpen={setError} />
                        </div>
                    )}
                    <form
                      onSubmit={createStatus}
                      className="flex flex-col mb-6 space-y-2 items-start sm:flex-row sm:space-x-2 sm:space-y-0 sm:items-center"
                    >
                      
                      <Input
                        type="text"
                        label="New Status Name"
                        value={newName}
                        onChange={e => {
                          const val = e.target.value.toUpperCase();
                          setNewName(val);
                        }}
                        className="w-full sm:flex-grow uppercase"
                        style={{ textTransform: 'uppercase' }}
                      />
                      <Button
                        type="submit"
                        variant="outlined"
                        color="blue"
                        className="flex items-center justify-center w-full sm:w-auto gap-2"
                      >
                        <FaPlus /> Add
                      </Button>
                    </form>


                    {loading ? (
                        <Typography>Loading...</Typography>
                    ) : (
                        <table className="w-full table-auto border-collapse">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border px-4 py-2 text-left">ID</th>
                                    <th className="border px-4 py-2 text-left">Name</th>
                                    <th className="border px-4 py-2 text-center">Active</th>
                                    <th className="border px-4 py-2 text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {statuses && Array.isArray(statuses) && statuses.map((status) => (
                                    <tr key={status.id} className="hover:bg-gray-50">
                                        <td className="border px-4 py-2">{status.id}</td>
                                        
                                        <td className="border px-4 py-2">
                                            {editingId === status.id ? (
                                                <Input
                                                    type="text"
                                                    size="sm"
                                                    value={editName}
                                                    onChange={(e) => setEditName(e.target.value.toUpperCase())}
                                                    className="uppercase"
                                                    style={{ textTransform: 'uppercase' }}
                                                />
                                            ) : (
                                                <Typography className="uppercase">{status.name}</Typography>
                                            )}
                                        </td>
                                        <td className="border px-4 py-2">
                                            {editingId === status.id ? (
                                                <label className="inline-flex cursor-pointer mx-auto flex justify-center items-center">
                                                    <input
                                                        type="checkbox"
                                                        className="sr-only peer"
                                                        checked={editActive}
                                                        onChange={(e) => setEditActive(e.target.checked)}
                                                    />
                                                    <div
                                                        className="w-11 h-6 bg-gray-200 rounded-full transition-colors peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-300 peer-checked:bg-blue-600 peer-checked:after:translate-x-full relative after:content-[''] after:absolute after:top-1 after:left-1 after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-transform"
                                                    />
                                                </label>
                                            ) : status.active ? (
                                                <div className="flex justify-center items-center">
                                                    <FaCheck className="text-green-700 flex justify-center items-center" />
                                                </div>
                                            ) : (
                                                <div className="flex justify-center items-center">
                                                    <FaTimes className="text-red-700 flex justify-center items-center" />
                                                </div>
                                            )}
                                        </td>
                                        <td className="border px-4 py-2 text-center space-y-2 sm:space-y-0 sm:space-x-2">
                                            {editingId === status.id ? (
                                                <>
                                                    <Button onClick={() => saveEdit(status.id)} className="bg-transparent shadow-none">
                                                        <FaCheck className="text-green-700" />
                                                    </Button>
                                                    <Button onClick={cancelEdit} className="bg-transparent shadow-none">
                                                        <FaTimes className="text-orange-700" />
                                                    </Button>
                                                </>
                                            ) : (
                                                <>
                                                    <Button onClick={() => startEdit(status)} className="bg-transparent shadow-none">
                                                        <FaPenAlt className="text-blue-gray-700" />
                                                    </Button>
                                                    <Button onClick={() => deleteStatus(status.id)} className="bg-transparent shadow-none">
                                                        <FaTrash className="text-red-700" />
                                                    </Button>
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    )}
                </CardBody>
            </Card>
        </>
    );
};

export default OwnersStatus;
